import { createCircleIcon } from '../createIcon.tsx';

export const XCircleIcon = createCircleIcon(
	'XCircleIcon',
	<>
		<line x1="15" y1="9" x2="9" y2="15" />
		<line x1="9" y1="9" x2="15" y2="15" />
	</>,
);
